import React, { useState, useEffect } from "react";
import { API_ENDPOINTS } from "../../config/api";
import { useAuth } from "../../context/AuthContext";
import { Container, Spinner, Alert, Table, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getAuthHeaders } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    fetchUsers();
  }, [getAuthHeaders]);

  async function fetchUsers() {
    try {
      const response = await fetch(API_ENDPOINTS.users.getAll, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeaders(),
        },
      });
      if (!response.ok) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }
      const data = await response.json();
      setUsers(data.data || []);
      console.log("Users fetched successfully:", data);
    } catch (error) {
      console.error("Error fetching users:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  }

  const handleDeleteUser = async (UserId) => {
    //will delete a user
  };

  if (loading) {
    return (
      <Container className="py-4 text-center">
        <Spinner animation="border" role="status" className="me-2" />
        <span>Loading users...</span>
      </Container>
    );
  }

  return (
    <div>
      {/* bootstrap table to display users with a nice style consistent with the rest of the app */}

      {/* page title and subtitle section */}
      <section className="mb-4">
        <div className="text-center py-4 bg-dark text-white rounded-3 shadow">
          <h1 className="display-4 fw-bold mb-0"> Admin Users</h1>
          <p className="mb-0 opacity-75">Manage and view all your admin users</p>
        </div>
      </section>

      <Table striped bordered hover className="re-table bg-white rounded shadow-sm">
        <thead>
          <tr>
            <th>Name</th>
            <th>Role</th>
            <th>Phone Number</th>
            <th>Created At</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user._id}>
              <td data-label="Name">
                {user.firstName} {user.lastName}
              </td>
              <td data-label="Role">{user.role}</td>
              <td data-label="Phone Number">{user.phone}</td>
              <td data-label="Created At">
                {new Date(user.createdAt).toLocaleDateString("en-TT", {
                  //date and time in Trinidad and Tobago
                  timeZone: "America/Port_of_Spain",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                  hour12: false,
                })}
              </td>
              <td data-label="">
                {/* I want buttons side by side */}
                <div className="d-flex gap-1">
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => navigate(`/users/${user._id}`)}
                  >
                    View
                  </Button>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => handleDeleteUser(user._id)}
                  >
                    Delete
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {error && (
        <Alert variant="danger" className="mt-3">
          {error}
        </Alert>
      )}
    </div>
  );
};

export default Users;
